import React from "react";

export default (props) => (
  <svg width="21" height="25" viewBox="0 0 28 35" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M.469.726l27.425 16.97L.469 34.666z" /></svg>
)